export default "__VITE_ASSET__eRi1ueTG__"